import { Routes } from '@angular/router';
import {
    AddbannerComponent,
    AddblogComponent,
    AddcolleagueComponent,
    BannersComponent,
    BlogComponent,
    ColleaguesComponent,
    HomeConfigComponent,
    SigninComponent,
    SiteConfigComponent,
    UpdatebannerComponent,
    UpdateblogComponent,
    UpdateHomeConfigComponent,
    UpdateHomeInfoComponent
} from '@prekog/common-ui';
import { AddCategoryComponent } from './categories/addcategory/addcategory.component';
import { CategoriesComponent } from './categories/categories.component';
import { UpdateCategoryComponent } from './categories/updatecategory/updatecategory.component';
import { ClientsComponent } from './clients/clients.component';
import { AddNewsletterComponent } from './email/add-newsletter/add-newsletter.component';
import { EditEmailComponent } from './email/edit-email/edit-email.component';
import { EmailTemplateListComponent } from './email/email-template-list/email-template-list.component';
import { ProductsaleComponent } from './onsaleperiods/addproductsonsale/addproductsonsale.component';
import { OnsaleperiodsComponent } from './onsaleperiods/onsaleperiods.component';
import { UpdateonsaleComponent } from './onsaleperiods/updateonsale/updateonsale.component';
import { GetordersComponent } from './order/getorders/getorders.component';
import { AddpackageComponent } from './packages/addpackage/addpackage.component';
import { PackagesComponent } from './packages/packages.component';
import { UpdatepackageComponent } from './packages/updatepackage/updatepackage.component';
import { ProductListComponent } from './products/product-list/product-list.component';
import { AddproductstoserieComponent } from './series/addproductstoserie/addproductstoserie.component';
import { AddserieComponent } from './series/addserie/addserie.component';
import { SeriesComponent } from './series/series.component';
import { UpdateserieComponent } from './series/updateserie/updateserie.component';

import { AddFestivalComponent } from './festivals/addfestival/addfestival.component';
import { FestivalsComponent } from './festivals/festivals.component';
import { AddPartnerComponent } from './partners/addpartner/addpartner.component';
import { PartnerDetailsComponent } from './partners/partnerdetails/partnerdetails.component';
import { PartnersComponent } from './partners/partners.component';
import { AddProductEventComponent } from './productevents/addproductevent/addproductevent.component';
import { EditProductEventComponent } from './productevents/editproductevent/editproductevent.component';
import { ProductEventsComponent } from './productevents/productevents.component';
import { OrderdiscountedproductsComponent } from './products/order-discounted-products/order-discounted-products.component';
import { OrderNoveltyProductsComponent } from './products/order-novelty-products/order-novelty-products.component';
import { ProductFormComponent } from './products/product-form/product-form.component';
import { StatisticsComponent } from './statistics/statistics.component';

export const routes: Routes = [
    { path: '', component: SigninComponent },
    { path: 'getorders', component: GetordersComponent },
    { path: 'clients', component: ClientsComponent },
    { path: 'addproduct', component: ProductFormComponent },
    { path: 'products', component: ProductListComponent },
    { path: 'packages', component: PackagesComponent },
    { path: 'packages/:routerLink', component: UpdatepackageComponent },
    { path: 'products/:routerLink', component: ProductFormComponent },
    { path: 'addpackage', component: AddpackageComponent },
    { path: 'series', component: SeriesComponent },
    { path: 'series/:routerLink', component: UpdateserieComponent },
    { path: 'addserie', component: AddserieComponent },
    { path: 'addserie/:id', component: AddproductstoserieComponent },
    { path: 'addproductsale', component: ProductsaleComponent },
    { path: 'onsaleperiod', component: OnsaleperiodsComponent },
    { path: 'onsaleperiod/:routerLink', component: UpdateonsaleComponent },
    { path: 'banners', component: BannersComponent },
    { path: 'banners/:id', component: UpdatebannerComponent },
    { path: 'addbanner', component: AddbannerComponent },
    { path: 'homeconfig', component: HomeConfigComponent },
    { path: 'homeconfig/:component', component: UpdateHomeConfigComponent },
    { path: 'updatehomeinfo', component: UpdateHomeInfoComponent },
    { path: 'addblog', component: AddblogComponent },
    { path: 'blog', component: BlogComponent },
    { path: 'blog/:routerLink', component: UpdateblogComponent },
    { path: 'siteconfig', component: SiteConfigComponent },
    { path: 'colleagues', component: ColleaguesComponent },
    { path: 'addcolleague', component: AddcolleagueComponent },
    { path: 'categorys', component: CategoriesComponent },
    { path: 'addcategory', component: AddCategoryComponent },
    { path: 'categorys/:id', component: UpdateCategoryComponent },
    { path: 'productevents', component: ProductEventsComponent },
    { path: 'addproductevent', component: AddProductEventComponent },
    { path: 'editproductevent', component: EditProductEventComponent },
    { path: 'statistics', component: StatisticsComponent },
    { path: 'addpartner', component: AddPartnerComponent },
    { path: 'partners', component: PartnersComponent },
    { path: 'partnerdetails', component: PartnerDetailsComponent },
    { path: 'festivals', component: FestivalsComponent },
    { path: 'addfestival', component: AddFestivalComponent },
    { path: 'email', component: EmailTemplateListComponent },
    { path: 'editemail', component: EditEmailComponent },
    { path: 'addnewsletter', component: AddNewsletterComponent },
    { path: 'orderdiscountedproducts', component: OrderdiscountedproductsComponent },
    { path: 'ordernoveltyproducts', component: OrderNoveltyProductsComponent }
];
